export const engagementEmailTemplates = "/engagement/email_templates";

export const engagementEmailTemplateSources = "/engagement/email_template_sources" as const;
